export default __webpack_public_path__ + "diversity-component.5df1c1c8.png";